export default __webpack_public_path__ + "static/media/join_community.408730ce.png";